import React from "react";
import PageShell from "../components/PageShell";
import About from "../components/About";

export default function SobrePage() {
  return (
    <PageShell testId="page-sobre">
      <About />
    </PageShell>
  );
}
